/**
 * Стартовый набор новостей для mock-хранилища. Фото у нас нет — рисуем SVG
 * 16:9: фон-градиент и крупный значок-эмблема. Уйдёт вместе с этой папкой,
 * когда появится API.
 */
import type { NewsDto } from '../contract'

function photo(from: string, to: string, mark: string): string {
  const svg =
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 675">` +
    `<defs><linearGradient id="g" x1="0" y1="0" x2="1" y2="1">` +
    `<stop offset="0" stop-color="${from}"/><stop offset="1" stop-color="${to}"/>` +
    `</linearGradient></defs>` +
    `<rect width="1200" height="675" fill="url(#g)"/>` +
    `<circle cx="960" cy="140" r="220" fill="#fff" opacity=".28"/>` +
    `<circle cx="180" cy="600" r="160" fill="#fff" opacity=".18"/>` +
    `<text x="600" y="400" font-size="220" text-anchor="middle" fill="#fff" opacity=".9" ` +
    `font-family="system-ui,-apple-system,Segoe UI,Roboto,sans-serif" font-weight="700">${mark}</text>` +
    `</svg>`
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`
}

interface SeedNews {
  id: number
  photo: string
  date: string
  ru: [title: string, lead: string, body: string]
  uz: [title: string, lead: string, body: string]
}

function news({ id, photo: url, date, ru, uz }: SeedNews): NewsDto {
  return {
    id,
    title_ru: ru[0],
    title_uz: uz[0],
    lead_ru: ru[1],
    lead_uz: uz[1],
    body_ru: ru[2],
    body_uz: uz[2],
    photo_key: url,
    photo_url: url,
    is_published: true,
    published_at: date,
    created_at: date,
    updated_at: date,
  }
}

export const SEED_NEWS: NewsDto[] = [
  news({
    id: 1,
    photo: photo('#2fa37a', '#0b6b4f', '+1'),
    date: '2026-10-10T08:00:00.000Z',
    ru: [
      'Открыли новую аптеку на Чиланзаре',
      'Работает круглосуточно, есть самовывоз заказов из приложения.',
      '<p>В квартале Чиланзар-9 открылась новая аптека сети. Она работает <strong>круглосуточно</strong>, а заказ из приложения можно забрать уже через 30 минут.</p><h2>Что есть в аптеке</h2><ul><li>рецептурный отдел;</li><li>измерение давления;</li><li>парковка у входа.</li></ul><p>Адрес и маршрут — в разделе <a href="/stores">«Аптеки»</a>.</p>',
    ],
    uz: [
      'Chilonzorda yangi dorixona ochildi',
      'Kecha-kunduz ishlaydi, ilovadan buyurtmani olib ketish mumkin.',
      '<p>Chilonzor-9 mavzesida tarmoqning yangi dorixonasi ochildi. U <strong>kecha-kunduz</strong> ishlaydi, ilovadagi buyurtmani 30 daqiqada olib ketish mumkin.</p><p>Manzil — <a href="/stores">«Dorixonalar»</a> bo‘limida.</p>',
    ],
  }),
  news({
    id: 2,
    photo: photo('#f2b45a', '#d9792b', '%'),
    date: '2026-10-08T08:00:00.000Z',
    ru: [
      'Двойной кэшбэк на витамины до конца октября',
      'Витамины и БАДы возвращают вдвое больше баллов.',
      '<p>До 31 октября покупки из категории <a href="/catalog">«Витамины и БАД»</a> возвращают <mark>двойной кэшбэк</mark>. Баллы приходят после оплаты и не сгорают.</p><blockquote>Акция действует и в аптеках, и в приложении.</blockquote>',
    ],
    uz: [
      'Oktyabr oxirigacha vitaminlarga ikki baravar keshbek',
      'Vitaminlar va BAD ikki baravar ko‘p ball qaytaradi.',
      '<p>31-oktyabrgacha <a href="/catalog">«Vitaminlar va BAD»</a> turkumidagi xaridlar <mark>ikki baravar keshbek</mark> qaytaradi.</p>',
    ],
  }),
  news({
    id: 3,
    photo: photo('#7aa7e6', '#3b5fae', '24'),
    date: '2026-10-05T08:00:00.000Z',
    ru: [
      'Режим работы аптек в праздничные дни',
      'Большинство аптек работают как обычно, круглосуточные — без перерыва.',
      '<p>В праздничные дни аптеки сети работают по обычному графику. Круглосуточные аптеки открыты без перерыва.</p><table><thead><tr><th>Аптека</th><th>Часы</th></tr></thead><tbody><tr><td>Чиланзар-9</td><td>24/7</td></tr><tr><td>Юнусабад</td><td>08:00–22:00</td></tr></tbody></table>',
    ],
    uz: [
      'Bayram kunlari dorixonalar ish tartibi',
      'Ko‘pchilik dorixonalar odatdagidek ishlaydi.',
      '<p>Bayram kunlari tarmoq dorixonalari odatdagi jadval bo‘yicha ishlaydi.</p>',
    ],
  }),
]
